import Layout from "@/modules/setting/setting-layout"
import HomeSetting from "@/modules/setting/component/Home"
import UsersSetting from "@/modules/setting/component/Users"
import Settings from "@/modules/setting/component/Settings"
import MailTest from "@/modules/setting/component/MailTest"
import OrganizationHome from "@/modules/organization/organization-layout"
import YourData from "@/modules/setting/component/YourData"

const SettingRouter = {
	path: "/settings",
	name: "settings",
	component: Layout,
	children: [
		//COMMONS
		{
			path: "",
			name: "settings.profile",
			component: HomeSetting,
			props: true
		},
		{
			path: "profile",
			name: "settings.profile",
			component: HomeSetting,
			props: true
		},

		//SCUOLE
		{
			path: "organizations",
			name: "settings.organizations",
			component: OrganizationHome,
			props: true
		},
		//dati
		{
			path: "your-data",
			name: "settings.data",
			component: YourData,
			props: true
		},

		//APICELLA
		{
			path: "users",
			name: "settings.users",
			component: UsersSetting,
			props: true
		},
		{
			path: "sitesettings",
			name: "settings.sitesettings",
			component: Settings,
			props: true
		},
		{
			path: "mailtest",
			name: "settings.mailtest",
			component: MailTest,
			props: true
		}
	]
}

export default SettingRouter
